import { sleep, calculateStats, getValuesForPath } from "./utils";

export const getAccelerometer = () => {
  if (!("Accelerometer" in window)) return undefined; // Accelerometer isn't supported by some browsers like Firefox.

  const acl = new window.Accelerometer({ frequency: 60 });
  return acl;
};

export const getAccelerometerRead = async () => {
  const acl = getAccelerometer();
  if (!acl) return undefined;

  let reading;
  const listener = () => {
    const { x, y, z } = acl;
    reading = { x, y, z };
  };
  acl.addEventListener("reading", listener);
  acl.start();

  // Wait for a second to get a reading.
  await sleep(1000);

  acl.removeEventListener("reading", listener);
  acl.stop();

  return reading;
};

// Same split as getDeviceOrientationRead in gyroscope.js
// (window motion events have no denial callback either).
export const getDeviceMotionRead = async () => {
  if (!("ondevicemotion" in window)) return undefined; // Not supported.

  const readings = [];
  let lastReading;
  const listener = (event) => {
    const reading = {
      ...event, // Include the event in case it contains extra information.
      acceleration: {
        x: event?.acceleration?.x,
        y: event?.acceleration?.y,
        z: event?.acceleration?.z,
      },
      accelerationIncludingGravity: {
        x: event?.accelerationIncludingGravity?.x,
        y: event?.accelerationIncludingGravity?.y,
        z: event?.accelerationIncludingGravity?.z,
      },
      rotationRate: {
        alpha: event?.rotationRate?.alpha,
        beta: event?.rotationRate?.beta,
        gamma: event?.rotationRate?.gamma,
      },
      interval: event?.interval,
    };
    readings.push(reading);
    lastReading = reading;
  };
  window.addEventListener("devicemotion", listener);

  // Collect readings over 2 seconds.
  await sleep(2000);

  window.removeEventListener("devicemotion", listener);

  if (readings.length === 0) return []; // Supported, no samples taken.

  const stats = {
    acceleration: {
      x: calculateStats(getValuesForPath(readings, 'acceleration.x')),
      y: calculateStats(getValuesForPath(readings, 'acceleration.y')),
      z: calculateStats(getValuesForPath(readings, 'acceleration.z')),
    },
    accelerationIncludingGravity: {
      x: calculateStats(getValuesForPath(readings, 'accelerationIncludingGravity.x')),
      y: calculateStats(getValuesForPath(readings, 'accelerationIncludingGravity.y')),
      z: calculateStats(getValuesForPath(readings, 'accelerationIncludingGravity.z')),
    },
    rotationRate: {
      alpha: calculateStats(getValuesForPath(readings, 'rotationRate.alpha')),
      beta: calculateStats(getValuesForPath(readings, 'rotationRate.beta')),
      gamma: calculateStats(getValuesForPath(readings, 'rotationRate.gamma')),
    },
    interval: calculateStats(getValuesForPath(readings, 'interval')),
  };
  return {
    lastReading,
    stats,
    sampleCount: readings.length,
  };
};
